<template>
  <v-layout mt-4 child-flex>
    <Table
      table-title="Associates Table"
      :headers="associatesTableHeaders"
      :items="associates"
      icon="domain"
      :actions="actions"
      :items-per-page="20"
      :primaryActionText="canInviteAssociate ? 'New Associate' : false"
      primaryActionIcon="add"
      @primary-action-event="inviteAssociateModal = true"
    />
    <invite-associate-modal
      v-if="inviteAssociateModal"
      :title="inviteAssociateModalTitle"
      :inviteAssociateModal.sync="inviteAssociateModal"
      @invite="inviteAssociate"
    />
  </v-layout>
</template>

<script>
import request from "@/modules/request";
import Table from "@/components/Table";
import moment from "moment";
import { hasPermission } from "@/modules/rbac/permission-manifest";
import InviteAssociateModal from "@/components/shared/modals/InviteAssociateModal";
import { errorMapper } from "@/modules/errorMessages";

export default {
  name: "Associates",
  inject: ["snackBar", "reactiveInjected"],
  async mounted() {
    await this.getAssociates();
    await this.getPermissions();
  },
  components: {
    Table,
    InviteAssociateModal,
  },
  data() {
    return {
      inviteAssociateModal: false,
      inviteAssociateModalTitle: "Add Associate",
      canInviteAssociate: hasPermission(
        "canInviteAssociate",
        null,
        this.reactiveInjected.activeUser
      ),
      loading: true,
      editAssociateModal: false,
      associates: [],
      associatesTableHeaders: [
        {
          text: "Email",
          value: "email",
        },
        {
          text: "First Name",
          value: "firstName",
        },
        {
          text: "Last Name",
          value: "lastName",
        },
        {
          text: "Role",
          value: "roles[0].name",
        },
        {
          text: "Phone #",
          value: "phoneNumber",
        },
        {
          text: "",
          value: "action",
        },
      ],
      editAssociate: {},
      permissions: [],
      actions: [
        {
          color: "primary",
          click: this.viewAssociate,
          text: "View",
        },
      ],
    };
  },
  methods: {
    async inviteAssociate(associate) {
      return request
        .callInternal({
          method: "post",
          route: "/api/admin/inviteassociate",
          data: associate,
        })
        .then((results) => {
          this.$swal({
            title: "Congratulations!",
            text: `${associate.firstName} has been invited. ${associate.firstName} will receive instructions on how to complete the registration process.`,
            icon: "success",
          });
          this.inviteAssociateModal = false;
        })
        .catch((error) => {
          const errorMessage = errorMapper["duplicate-associate-email"](
            associate
          );
          this.$swal({
            title: "Error!",
            text: errorMessage,
            icon: "error",
          });
        });
    },
    async getAssociates() {
      const results = await request.callInternal({
        method: "get",
        route: "/api/admin/associates",
      });
      this.associates = results.data;
      this.loading = false;
    },
    viewAssociate(associate) {
      this.$router.push({
        name: "Associate",
        params: {
          id: associate._id,
        },
      });
    },
    async getPermissions() {
      await request
        .callInternal({
          method: "get",
          route: `/api/admin/permissions`,
        })
        .then((results) => {
          this.permissions = results.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    },
  },
};
</script>
